var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNh24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6263 3.61772L7.37805 1.34912L11.5689 9.37648L15.7598 1.40729L11.6263 3.61772ZM14.8417 4.25755L20.2382 2.04712V6.0608L17.1381 7.45686C18.9752 8.96926 20.1808 11.2379 20.1808 13.7391C20.1808 18.2763 16.277 21.9992 11.512 21.9992C6.68966 21.9992 2.84326 18.3345 2.84326 13.7391C2.84326 11.1797 4.04885 8.91109 6.00075 7.34052L2.90067 5.94446V1.93078L8.2397 4.19938L9.10084 5.76995L11.0527 9.49278C8.8712 9.78363 7.20634 11.5869 7.20634 13.7391C7.20634 16.0659 9.21566 17.9855 11.6842 17.9855C14.1528 17.9855 16.1621 16.1241 16.1621 13.7391C16.1621 11.5287 14.3825 9.66729 12.0861 9.49278L13.9232 5.88629H13.9806L14.8417 4.25755Z",
    fill: "#FFDC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNh24);
export default __webpack_public_path__ + "static/media/NH투자증권-24.1a4996e9eed283c6320c8a75f3edda69.svg";
export { ForwardRef as ReactComponent };